import { SCORECARD_STATUS } from 'talent_search/shared/types';

export type MyGreenhouseFilters = {
  page: number;
  perPage: number;
  savedForLater: boolean;
  feedbackStatus: SCORECARD_STATUS;
  minExperience: string | null;
  maxExperience: string | null;
  companyNameFilters: Array<{ id: string; mode: string; value: string }>;
  educationFilters: unknown[];
  workPreferenceLanguages: unknown[];
  workPreferenceEmploymentTypes: unknown[];
  workPreferenceWorksites: unknown[];
  workPreferenceLocations: unknown[];
  workPreferenceWillingToRelocate: boolean;
  canHave: string[];
  mustHave: string[];
  doesNotHave: string[];
};

export const MY_GREENHOUSE_DEFAULT_VALUES: MyGreenhouseFilters = {
  page: 1,
  perPage: 50,
  savedForLater: false,
  feedbackStatus: SCORECARD_STATUS.ALL,
  minExperience: null,
  maxExperience: null,
  companyNameFilters: [],
  educationFilters: [],
  workPreferenceLanguages: [],
  workPreferenceEmploymentTypes: [],
  workPreferenceWorksites: [],
  workPreferenceLocations: [],
  workPreferenceWillingToRelocate: false,
  canHave: [],
  mustHave: [],
  doesNotHave: [],
};
